import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { nav, brand } from '../mock';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 btn-transition ${
        scrolled ? 'bg-[#FAF6EE]/85 backdrop-blur-md border-b border-[#E7DFCF]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full bg-[#1E3A2B] flex items-center justify-center text-[#FAF6EE] font-serif-display text-lg">
            b
          </div>
          <div className="leading-tight">
            <div className="font-serif-display text-[17px] text-[#1E3A2B]">Byron Batten</div>
            <div className="text-[11px] tracking-[0.18em] uppercase text-[#6B8E4E]">Consultancy</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `link-underline text-[14px] tracking-wide ${
                  isActive ? 'text-[#1E3A2B] font-medium' : 'text-[#3d4a41]'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          className="hidden md:inline-flex items-center gap-2 btn-transition bg-[#1E3A2B] hover:bg-[#152B20] text-[#FAF6EE] px-5 py-2.5 rounded-full text-[13px] tracking-wide"
        >
          Start a conversation
          <ArrowUpRight className="w-4 h-4" />
        </Link>

        <button
          className="md:hidden p-2 text-[#1E3A2B]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAF6EE] border-t border-[#E7DFCF]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `font-serif-display text-2xl ${isActive ? 'text-[#1E3A2B]' : 'text-[#3d4a41]'}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center gap-2 bg-[#1E3A2B] text-[#FAF6EE] px-5 py-3 rounded-full w-fit"
            >
              Start a conversation <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
